import React, { Component } from 'react';
import { PickList } from 'primereact/picklist';


class ListAlternatives extends Component {

    constructor(props) {
        super(props);

        this.state = {
            source: [],
            target: [],
        };

        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {

        this.setState({
            source: JSON.parse(this.props.alternatives),
        });
    }

    onChange(event) {
        this.setState({
            source: event.source,
            target: event.target
        });
    }

    templateAlternative(alternative) {
        return (
            <div className="p-clearfix">
                {alternative.name ? <div className="text">{alternative.name}</div> : ''}
                {alternative.description ? <div className="text">{alternative.description}</div> : ''}
            </div>
        );
    }

    render() {
        return (
            <div className="card">

                <div className="content-section implementation">
                    <PickList source={this.state.source} target={this.state.target} itemTemplate={this.templateAlternative}
                        sourceHeader="Available" targetHeader="Selected" responsive={true}
                        onChange={this.onChange}></PickList>
                </div>

            </div>
        );
    }
}

export default ListAlternatives;


// WEBPACK FOOTER //
// ./src/components/ListAlternatives.js